<div class="d-flex flex-row flex-wrap page-wrapper">
  @for (child of tree; track child.id) {
    @switch (child.type) {
      @case (ContentType.PAGE) {
        <div class="card-wrapper">
          <a [routerLink]="['/information', child.id]">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-row align-items-center h-100">
                  <div class="d-flex flex-row align-items-center h-100 icon-wrapper">
                    <span class="material-symbols-outlined item-icon display-4 text-center">description</span>
                  </div>
                  <h3 class="card-title mb-0" translate>
                    {{child.name}}
                  </h3>
                </div>
              </div>
            </div>
          </a>
        </div>
      }
      @case (ContentType.FOLDER) {
        <div class="card-wrapper">
          <a [routerLink]="['/information', child.id]">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-column h-100">
                  <div class="d-flex flex-row align-items-center flex-grow-1">
                    <div class="d-flex flex-row align-items-center h-100 icon-wrapper">
                      <span class="material-symbols-outlined item-icon display-4 text-center p-1">folder</span>
                    </div>
                    <div>
                      <h3 class="card-title mb-0" translate>
                        {{child.name}}
                      </h3>
                      <div class="text-muted">
                        @if(!child.children || child.children!.length === 0) {
                          {{'contents.noItem' | translate}}
                        } @else if(child.children!.length === 1) {
                          {{'contents.singleItem' | translate }}
                        } @else {
                          {{'contents.itemCount' | translate: {count: child.children!.length} }}
                        }
                      </div>
                    </div>
                  </div>
                  <p class="ps-2 mt-2 mb-0" *ngIf="child.content">{{child.content}}</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      }
    }
  }
</div>
